// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_headerWrapper__AzyC\\+ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 110px;
  width: 100%;
  box-shadow: 0px 4px 24px 0px #40404014;
  background-color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
}
.Header_logoWrapper__Rq5fS {
  width: 139px;
  height: 64px;
  padding-left: 5%;
}
.Header_pagesWrapper__OxJAt {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 80%;
}
.Header_headerTextButton__7cKYa,
.Header_btn__B2xBJ {
  transition: color 300ms ease-in-out;
}
.Header_headerTextButton__7cKYa {
  color: #090446;
  text-decoration: none;
  font-size: 16px;
  font-weight: 700;
  font-family: "Open Sans";
}
.Header_headerTextButton__7cKYa:hover {
  cursor: pointer;
  color: #47a9f4;
}
.Header_btnWrapper__szDkr {
  width: 18%;
}
.Header_btn__B2xBJ {
  width: 94%;
  border-radius: 8px;
  height: 54px;
  padding: 16px, 24px, 16px, 24px;
  background-color: #47a9f4;
  color: #ffffff;
  border: none;
  font-size: 16px;
  font-weight: 700;
  font-family: "Open Sans";
}
.Header_btn__B2xBJ:hover {
  cursor: pointer;
  background-color: #3175a8;
}
.Header_activeLink__6P6If {
  color: #47a9f4;
}
.Header_menu__ddsbd {
  position: absolute;
  visibility: hidden;
}
.Header_mobileNav__F\\+VWh {
  display: flex;
  flex-direction: column;
  position: absolute;
  align-items: center;
  top: 110px;
  width: 100%;
  background-color: white;
  font-size: 16px;
  font-family: "Open Sans";
  font-weight: 600;
  visibility: hidden;
}

.Header_mobileLinks__wBAi0 {
  width: 100%;
  text-align: center;
  padding: 25px;
  text-decoration: none;
  color: #090446;
}

.Header_mobileBtnWrapper__M\\+euC {
  width: 80%;
}

.Header_mobileBtn__zvsqQ {
  width: 100%;
  padding: 15px 0;
  margin-bottom: 25px;
  border-radius: 8px;
  background-color: #47a9f4;
  color: #ffffff;
  border: none;
  font-size: 16px;
  font-weight: 700;
  font-family: "Open Sans";
}

.Header_logo__9YFPc {
  height: 70px;
  width: 230px;
}

@media screen and (max-width: 1280px) {
  .Header_mobileNav__F\\+VWh {
    visibility: visible;
  }
  .Header_menu__ddsbd {
    height: 40px;
    width: 40px;
    top: 16px;
    right: 30px;
    visibility: visible;
  }
  .Header_pagesWrapper__OxJAt {
    visibility: hidden;
    position: absolute;
    width: 0px;
  }
}

@media screen and (max-width: 570px) {
  .Header_menu__ddsbd {
    right: 16px;
  }
  .Header_headerWrapper__AzyC\\+ {
    box-shadow: none;
  }
  .Header_logo__9YFPc {
    height: 48px;
    width: 180px;
    padding-top: 6px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Header/Header.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,WAAW;EACX,sCAAsC;EACtC,yBAAyB;EACzB,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,UAAU;AACZ;AACA;;EAEE,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;EAClB;AACF","sourcesContent":[".headerWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 110px;\n  width: 100%;\n  box-shadow: 0px 4px 24px 0px #40404014;\n  background-color: #ffffff;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 100;\n}\n.logoWrapper {\n  width: 139px;\n  height: 64px;\n  padding-left: 5%;\n}\n.pagesWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  width: 80%;\n}\n.headerTextButton,\n.btn {\n  transition: color 300ms ease-in-out;\n}\n.headerTextButton {\n  color: #090446;\n  text-decoration: none;\n  font-size: 16px;\n  font-weight: 700;\n  font-family: \"Open Sans\";\n}\n.headerTextButton:hover {\n  cursor: pointer;\n  color: #47a9f4;\n}\n.btnWrapper {\n  width: 18%;\n}\n.btn {\n  width: 94%;\n  border-radius: 8px;\n  height: 54px;\n  padding: 16px, 24px, 16px, 24px;\n  background-color: #47a9f4;\n  color: #ffffff;\n  border: none;\n  font-size: 16px;\n  font-weight: 700;\n  font-family: \"Open Sans\";\n}\n.btn:hover {\n  cursor: pointer;\n  background-color: #3175a8;\n}\n.activeLink {\n  color: #47a9f4;\n}\n.menu {\n  position: absolute;\n  visibility: hidden;\n}\n.mobileNav {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  align-items: center;\n  top: 110px;\n  width: 100%;\n  background-color: white;\n  font-size: 16px;\n  font-family: \"Open Sans\";\n  font-weight: 600;\n  visibility: hidden;\n}\n\n.mobileLinks {\n  width: 100%;\n  text-align: center;\n  padding: 25px;\n  text-decoration: none;\n  color: #090446;\n}\n\n.mobileBtnWrapper {\n  width: 80%;\n}\n\n.mobileBtn {\n  width: 100%;\n  padding: 15px 0;\n  margin-bottom: 25px;\n  border-radius: 8px;\n  background-color: #47a9f4;\n  color: #ffffff;\n  border: none;\n  font-size: 16px;\n  font-weight: 700;\n  font-family: \"Open Sans\";\n}\n\n.logo {\n  height: 70px;\n  width: 230px;\n}\n\n@media screen and (max-width: 1280px) {\n  .mobileNav {\n    visibility: visible;\n  }\n  .menu {\n    height: 40px;\n    width: 40px;\n    top: 16px;\n    right: 30px;\n    visibility: visible;\n  }\n  .pagesWrapper {\n    visibility: hidden;\n    position: absolute;\n    width: 0px;\n  }\n}\n\n@media screen and (max-width: 570px) {\n  .menu {\n    right: 16px;\n  }\n  .headerWrapper {\n    box-shadow: none;\n  }\n  .logo {\n    height: 48px;\n    width: 180px;\n    padding-top: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerWrapper": `Header_headerWrapper__AzyC+`,
	"logoWrapper": `Header_logoWrapper__Rq5fS`,
	"pagesWrapper": `Header_pagesWrapper__OxJAt`,
	"headerTextButton": `Header_headerTextButton__7cKYa`,
	"btn": `Header_btn__B2xBJ`,
	"btnWrapper": `Header_btnWrapper__szDkr`,
	"activeLink": `Header_activeLink__6P6If`,
	"menu": `Header_menu__ddsbd`,
	"mobileNav": `Header_mobileNav__F+VWh`,
	"mobileLinks": `Header_mobileLinks__wBAi0`,
	"mobileBtnWrapper": `Header_mobileBtnWrapper__M+euC`,
	"mobileBtn": `Header_mobileBtn__zvsqQ`,
	"logo": `Header_logo__9YFPc`
};
export default ___CSS_LOADER_EXPORT___;
